import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';

export async function requestPresignedUrl(file: File): Promise<{
  data: { id: string; url: string; originalUrl: string; bucketName: string };
}> {
  return apiFetch<{
    data: { id: string; url: string; originalUrl: string; bucketName: string };
  }>(
    '/api/system/files/',
    {
      method: 'POST',
      body: JSON.stringify({
        filename: file.name,
        fileType: file.type,
        fileSize: file.size,
      }),
    },
    API_ROOT_URL,
  );
}

export function putFileToStorage(
  presignedUrl: string,
  file: File,
  onProgress?: (pct: number) => void,
): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    if (onProgress) {
      xhr.upload.addEventListener('progress', e => {
        if (e.lengthComputable)
          onProgress(Math.round((e.loaded / e.total) * 100));
      });
    }
    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error('File upload to storage failed'));
    });
    xhr.addEventListener('error', () =>
      reject(new Error('Network error during upload')),
    );
    xhr.open('PUT', presignedUrl);
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.send(file);
  });
}
